import React from 'react';
import { newsPageData } from '../data/pageData';
import PageTitle from '../components/PageTitle';
import { FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';

const NewsPage = () => {
    const newsList = newsPageData.news;
    return (
        <div className="bg-white text-gray-800">
            <PageTitle title={newsPageData.pageTitle} breadcrumbs={newsPageData.breadcrumbs} />
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="space-y-12">
                        {newsList.map((item, idx) => {
                            // Determine if image should be stacked
                            const stacked = item.imageStacked;
                            const stackedTop = stacked === true || stacked === 'top';
                            const stackedBottom = stacked === 'bottom';
                            // Stacked layout
                            if ((stackedTop || stackedBottom) && item.imageSrc) {
                                return (
                                    <div key={idx} className="bg-gray-50 p-8 md:p-12 rounded-xl shadow-2xl hover:shadow-yellow-500/10 transition-shadow duration-500 border border-gray-200">
                                        {stackedTop && (
                                            <img src={item.imageSrc} alt="News context" className="rounded-lg shadow-xl max-w-md w-full mx-auto mb-8 border border-gray-300" />
                                        )}
                                        <h3 className="text-sm uppercase text-yellow-600 tracking-wider font-semibold mb-3">{item.subtitle}</h3>
                                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 leading-tight">{item.title}</h2>
                                        {item.date && <p className="text-xs text-gray-500 mb-4">{item.date}</p>}
                                        {item.details && item.details.map((para, i) => (
                                            <p key={i} className="text-gray-700 mb-5 leading-relaxed" dangerouslySetInnerHTML={{ __html: para }} />
                                        ))}
                                        {item.ctaText && <p className="mt-8 font-light text-yellow-600 text-sm">{item.ctaText}</p>}
                                        {item.pdfUrl && (
                                            <a href={item.pdfUrl} target="_blank" rel="noopener noreferrer" className="inline-block mt-4 px-4 py-2 bg-yellow-500 text-black rounded shadow hover:bg-yellow-600 transition-colors duration-300 font-semibold">
                                                Download PDF
                                            </a>
                                        )}
                                        {stackedBottom && (
                                            <img src={item.imageSrc} alt="News context" className="rounded-lg shadow-xl max-w-md w-full mt-8 border border-gray-300" />
                                        )}
                                        {item.quote && (
                                            <div className="bg-gray-100 p-6 rounded-lg shadow-lg border border-gray-200 w-full mt-6">
                                                <p className="italic text-gray-600 text-center">{item.quote}</p>
                                                <div className="flex justify-center space-x-3 mt-5">
                                                    <a 
                                                        href="#" 
                                                        className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                                    >
                                                        <FaFacebookF />
                                                    </a>
                                                    <a 
                                                        href="#" 
                                                        className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                                    >
                                                        <FaTwitter />
                                                    </a>
                                                    <a 
                                                        href="#" 
                                                        className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                                    >
                                                        <FaLinkedinIn />
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            }
                            // Default: side-by-side layout
                            return (
                                <div key={idx} className="bg-gray-50 p-8 md:p-12 rounded-xl shadow-2xl hover:shadow-yellow-500/10 transition-shadow duration-500 border border-gray-200">
                                    <div className="flex flex-col lg:flex-row gap-10">
                                        <div className="lg:w-2/3">
                                            <h3 className="text-sm uppercase text-yellow-600 tracking-wider font-semibold mb-3">{item.subtitle}</h3>
                                            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 leading-tight">{item.title}</h2>
                                            {item.date && <p className="text-xs text-gray-500 mb-4">{item.date}</p>}
                                            {item.details && item.details.map((para, i) => (
                                                <p key={i} className="text-gray-700 mb-5 leading-relaxed" dangerouslySetInnerHTML={{ __html: para }} />
                                            ))}
                                            {item.ctaText && <p className="mt-8 font-light text-yellow-600 text-sm">{item.ctaText}</p>}
                                            {item.pdfUrl && (
                                                <a href={item.pdfUrl} target="_blank" rel="noopener noreferrer" className="inline-block mt-4 px-4 py-2 bg-yellow-500 text-black rounded shadow hover:bg-yellow-600 transition-colors duration-300 font-semibold">
                                                    Download PDF
                                                </a>
                                            )}
                                        </div>
                                        {item.imageSrc && (
                                            <div className="lg:w-1/3 flex flex-col items-center">
                                                <img src={item.imageSrc} alt="News context" className="rounded-lg shadow-xl max-w-xs w-full mb-8 border border-gray-300" />
                                                {item.quote && (
                                                    <div className="bg-gray-100 p-6 rounded-lg shadow-lg border border-gray-200 w-full">
                                                        <p className="italic text-gray-600 text-center">{item.quote}</p>
                                                        <div className="flex justify-center space-x-3 mt-5">
                                                            <a 
                                                                href="#" 
                                                                className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                                            >
                                                                <FaFacebookF />
                                                            </a>
                                                            <a 
                                                                href="#" 
                                                                className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                                            >
                                                                <FaTwitter />
                                                            </a>
                                                            <a 
                                                                href="#" 
                                                                className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                                            >
                                                                <FaLinkedinIn />
                                                            </a>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NewsPage;